module.exports = __webpack_public_path__ + "img/avatar_ico11.431af51a.jpg";